const loading = (state) => state.loading;
const pageTitle = (state) => state.pageTitle;
const branding = (state) => state.branding;

export default {
  loading,
  pageTitle,
  branding,
};
